var _classCallCheck = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var Base = require('./base');
var AngularHttpService = /*#__PURE__*/function (_Base) {
  "use strict";

  _inherits(AngularHttpService, _Base);
  var _super = _createSuper(AngularHttpService);
  function AngularHttpService() {
    _classCallCheck(this, AngularHttpService);
    return _super.apply(this, arguments);
  }
  _createClass(AngularHttpService, [{
    key: "request",
    value: function request(options, params) {
      var httpClient = this.connection;
      var HttpHeaders = this.options.HttpHeaders;
      if (!httpClient || !HttpHeaders) {
        throw new Error("Please pass angular's 'httpClient' (instance) and and object with 'HttpHeaders' (class) to feathers-rest");
      }
      var url = options.url;
      var _params$connection = params.connection,
        connection = _params$connection === void 0 ? {} : _params$connection;
      var headers = new HttpHeaders(Object.assign({
        Accept: 'application/json'
      }, this.options.headers, options.headers, connection.headers));
      var requestOptions = Object.assign({
        // method: options.method,
        body: options.body
      }, params.connection, {
        headers: headers
      });
      return new Promise(function (resolve, reject) {
        httpClient.request(options.method, url, requestOptions).subscribe(resolve, reject);
      }).catch(function (error) {
        var e = error.error;
        if (e) {
          throw typeof e === 'string' ? JSON.parse(e) : e;
        }
        throw error;
      });
    }
  }]);
  return AngularHttpService;
}(Base);
module.exports = AngularHttpService;